import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import EditorTypePropType from '../../prop-types/editor-type-prop-type';
import OperatorPropType from '../../prop-types/operator-type-prop-type';
import { operatorTypeNameFromOperatorType } from '../../constants/intl-messages/operator-type-messages';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { getOptionsForFilterOperatorByEditorType } from '../../helpers/options-for-filter-editor-type';
import { OPERATOR_TYPE_UNDEFINED } from '../../constants/filter-operator-type';
import sharedStyles from '../shared-styles.module.less';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import messages from '../../messages';

const OperatorSelector = ({ editorType, selectedOperatorType, onOperatorChange }) => {
  const { formatMessage } = useIntl();
  const options = getOptionsForFilterOperatorByEditorType(editorType);
  const oper = selectedOperatorType ? formatMessage(operatorTypeNameFromOperatorType(selectedOperatorType)) : undefined;
  if (selectedOperatorType === OPERATOR_TYPE_UNDEFINED) {
    return <FormattedMessage {...operatorTypeNameFromOperatorType(OPERATOR_TYPE_UNDEFINED)} />;
  }
  return (
    <DropdownMenu className={sharedStyles['filter-operator-selector']} dropdownMenuShouldHaveWidthOfButton>
      <DropdownMenuToggler ariaLabel={formatMessage(messages.filterOperator)} className={sharedStyles['dropdown-toggler']}>
        {oper}
      </DropdownMenuToggler>
      {options.map((option) => (
        <DropdownMenuItem key={option} onClick={() => onOperatorChange(option)} selected={option === selectedOperatorType}>
          {formatMessage(operatorTypeNameFromOperatorType(option))}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

OperatorSelector.propTypes = {
  editorType: EditorTypePropType.isRequired,
  selectedOperatorType: OperatorPropType.isRequired,
  onOperatorChange: PropTypes.func.isRequired,
};

export default OperatorSelector;
